<template>
  <div class="mod-info" style="padding-top: 70px">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$router.back()" class="header-back"></a>
      </div>
      <div class="header-center">
        <a @click="$parent.goNav('/')" class="header-logo">
          <img :src="$store.state.appInfo.site_logo || '/static/image/d11_logo_h5.png'" onerror="this.src = '/static/image/d11_logo_h5.png'" width="100%" />
        </a>
        <h4 class="header-title hide"></h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
      </div>
    </div>
    <div class="layout mt12">
      <div class="hd-tit">
        <h3>{{ type == 1 ? '修改登录密码' : '修改支付密码' }}</h3>
      </div>
      <form id="password_form" v-if="type == 1">
        <ul class="mod-forms">
          <li>
            <i class="old-icon"></i>
            <label>当前密码：</label>
            <div class="form-ipt">
              <input type="password" id="old_password" name="old_password" autocomplete="new-password" v-model="passwordInfo.password" class="txt-ipt" placeholder="旧密码" />
            </div>
          </li>

          <li>
            <i class="new-icon"></i>
            <label>新的密码：</label>
            <div class="form-ipt">
              <input type="password" id="new_password" name="new_password" autocomplete="new-password" v-model="passwordInfo.paypassword" maxlength="16" class="txt-ipt" placeholder="请输入新密码" />
            </div>
          </li>

          <li>
            <i class="repeat-icon"></i>
            <label>确认密码：</label>
            <div class="form-ipt">
              <input type="password" id="new_password_c" autocomplete="new-password" v-model="passwordInfo.newpasword" name="new_password_c" maxlength="16" class="txt-ipt" placeholder="确认密码" />
            </div>
          </li>
        </ul>
        <input class="confirm-sub orange-button mt20" type="button" id="change_btn" @click="editPassword(type)" value="提 交" />
      </form>
      <form id="password_form" v-if="type == 2">
        <ul class="mod-forms">
          <li>
            <i class="old-icon"></i>
            <label>当前密码：</label>
            <div class="form-ipt">
              <input type="password" id="old_password" name="old_password" autocomplete="new-password" v-model="passwordInfo.password" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" class="txt-ipt" placeholder="旧密码" />
            </div>
          </li>

          <li>
            <i class="new-icon"></i>
            <label>新的密码：</label>
            <div class="form-ipt">
              <input type="password" id="new_password" name="new_password" autocomplete="new-password" v-model="passwordInfo.paypassword" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" class="txt-ipt" placeholder="请输入新密码" />
            </div>
          </li>

          <li>
            <i class="repeat-icon"></i>
            <label>确认密码：</label>
            <div class="form-ipt">
              <input type="password" id="new_password_c" autocomplete="new-password" v-model="passwordInfo.newpasword" name="new_password_c" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" class="txt-ipt" placeholder="确认密码" />
            </div>
          </li>
        </ul>
        <input class="confirm-sub orange-button mt20" type="button" id="change_btn" @click="editPassword(type)" value="提 交" />
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'password',
  data() {
    return {
      passwordInfo: {},
      type: 1,
      psw1: true,
      psw2: true,
      psw3: true,
    };
  },
  created() {
    let that = this;
    let query = that.$route.query;

    if (query.type) {
      that.type = query.type * 1;
    }
  },
  methods: {
    changPsw(name) {
      this[name] = !this[name];
    },
    changtab() {
      let that = this;
      that.passwordInfo = {};
      that.info = {};
    },
    editPassword(pasType) {
      let that = this;
      if (!that.passwordInfo.password) {
        that.$parent.showTost(0, '请输入旧密码');
        return;
      }
      if (!that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '请输入新密码');
        return;
      }
      if (that.passwordInfo.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的旧密码长度');
        return;
      }
      if (that.passwordInfo.paypassword.length < 6) {
        that.$parent.showTost(0, '请输入正确的新密码长度');
        return;
      }
      if (!that.passwordInfo.newpasword) {
        that.$parent.showTost(0, '请输入确认密码');
        return;
      }
      if (that.passwordInfo.newpasword != that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (that.passwordInfo.password == that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '新旧密码不能一致！');
        that.passwordInfo = {};
        return;
      }
      let url = pasType == 1 ? '/api/editPassword' : '/api/editPayPassword';

      that.$parent.showLoading();
      that.$apiFun.post(url, that.passwordInfo).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        that.$parent.hideLoading();
        if (res.code == 200) {
          that.$parent.showTost(1, '密码修改成功！');
          that.passwordInfo = {};
          if (pasType == 1) {
            that.$parent.closeDaoTime();
            localStorage.clear();
            sessionStorage.clear();
            that.$store.commit('changUserInfo');
            that.$store.commit('changToken');
            that.$router.push({ path: '/login' });
          }
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.mod-forms li {
  height: 58px;
  line-height: 58px;
  border-radius: 4px;
  position: relative;
}
.mod-forms li .form-ipt {
  float: left;
  margin-left: 0;
  width: 85%;
}
.mod-forms li .form-ipt .txt-ipt {
  height: 58px;
  line-height: 58px;
  width: 100%;
}
.mod-forms li label {
  display: none;
}
.mod-forms li input::-webkit-input-placeholder {
  font-size: 18px;
  color: #757575;
}
.mod-forms li input::-moz-placeholder {
  font-size: 18px;
  color: #757575;
}
.mod-forms li i {
  display: block;
  width: 45px;
  height: 58px;
  float: left;
}
.mod-forms li a {
  display: block;
  width: 21px;
  height: 15px;
  position: absolute;
  right: 10px;
  top: 22px;
  background: url(/static/image/icon_eye.png) no-repeat center center;
  background-size: 21px 15px;
}
.mod-forms li a.captcha-refresh {
  background: none;
  top: 15px;
  right: 70px;
}
.mod-forms li i.old-icon {
  background: url(/static/image/icon_pwd.png) no-repeat center center;
  background-size: 20px 20px;
}
.mod-forms li i.new-icon {
  background: url(/static/image/icon_pwd1.png) no-repeat center center;
  background-size: 20px 20px;
}
.mod-forms li i.repeat-icon {
  background: url(/static/image/icon_pwd2.png) no-repeat center center;
  background-size: 20px 20px;
}
.mod-forms li i.captcha-icon {
  background: url(/static/image/icon_reg8.png) no-repeat center center;
  background-size: 20px 20px;
}
.login-wrap .log-btn,
.confirm-sub {
  height: 53px;
  line-height: 53px;
  border-radius: 0;
  background: url(/static/image/btn11.png) no-repeat;
  background-size: 100% 53px;
}
</style>



// WEBPACK FOOTER //
// src/components/password.vue